import { useState, useEffect } from 'react';
import { getBookings, getBookingsCount, Booking } from '../lib/bookings';

export function useBookings(businessId?: string) {
  const [bookings, setBookings] = useState<Booking[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState(true);
  const [totalCount, setTotalCount] = useState(0);

  const loadBookings = async () => {
    setError(null);
    setLoading(true);

    if (!businessId) {
      setLoading(false);
      setBookings([]);
      setHasMore(false);
      setTotalCount(0);
      return;
    }

    try {

      // Load all bookings without pagination
      const [data, count] = await Promise.all([
        getBookings(businessId).catch(err => {
          console.error('Error in getBookings:', err);
          throw new Error('Unable to load bookings. Please try again.');
        }),
        getBookingsCount(businessId)
      ]);

      setBookings(data);
      setTotalCount(count);
      setHasMore(false); // No pagination, so no more items to load

    } catch (err) {
      console.error('Error loading bookings:', err);
      setError(err instanceof Error ? err.message : 'Failed to load bookings');
      setBookings([]);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    loadBookings();
  }, [businessId]);

  return { 
    bookings, 
    loading, 
    loadingMore,
    error, 
    hasMore,
    totalCount,
    refetch: () => loadBookings()
  };
}